import { NavLink } from "react-router-dom";
import styled from "styled-components";

export const PageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  overflow: hidden;

  ${(props) => props.theme.sm`
    display: none;
  `}
`;

export const BurgerWrapper = styled.div`
  flex-shrink: 0;
  margin-left: 12px;
`;

export const BurgerMenuLink = styled(NavLink)`
  display: block;
  padding: 10px 16px;
  font-size: 14px;
  text-decoration: none;
  white-space: nowrap;
  color: ${(props) => props.theme.elevatedText};
  transition: background-color 0.2s;

  &:hover {
    background-color: ${(props) => props.theme.subtleHover};
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${(props) => props.theme.divider};
  }

  &.active {
    background-color: ${(props) => props.theme.activeBg};
    color: ${(props) => props.theme.activeText};
    font-weight: 600;
  }
`;

export const ParcelsLink = styled(NavLink)<{ $folded?: boolean }>`
  position: relative;
  margin-left: 12px;
  letter-spacing: 0.5px;
  text-decoration: none;
  padding: 10px 16px;
  border-radius: 7px;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
  flex-shrink: 0;
  visibility: ${({ $folded }) => ($folded ? "hidden" : "visible")};
  transition: background-color 0.2s, color 0.2s;
  color: ${(props) => props.theme.navText};

  &:hover {
    background-color: ${(props) => props.theme.subtleHover};
  }

  &::before {
    content: "";
    position: absolute;
    transform: scale(0);
    transition: transform cubic-bezier(0, 0, 0.7, 2.5) 0.3s;
    background-color: ${(props) => props.theme.red};
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 10px;
    color: ${(props) => props.theme.buttonFilledText};
    right: -5px;
    top: -4px;
    width: 17px;
    height: 17px;
    border-radius: 50%;
  }

  &.active {
    background-color: ${(props) => props.theme.activeBg};
    color: ${(props) => props.theme.activeText};
    box-shadow: ${(props) => props.theme.activeShadow};
    text-shadow: ${(props) => props.theme.activeTextShadow};
    border: ${(props) => props.theme.activeBorder};
    font-weight: 600;

    &::before {
      display: none;
    }
  }
`;

